import React from 'react';
import { Link } from 'react-router-dom';

const AboutAlex: React.FC = () => {
  return (
    <div className="text-justify">
      <br />
      <h3>About Alex</h3>
      <br />
      <h5>What I'm doing now</h5>
      <p>
        I'm the founder of <a href="https://www.balances.ai">Balances.ai</a>, a beautiful, modern bookkeeping platform built to help small businesses stay on top of their finances.
      </p>
      <p>
        Before that, I headed up the product management team at <a href="https://pilot.com">Pilot.com</a>, building the future of the financial back-office for small businesses. I'm also an instrument-rated pilot.
      </p>
      <p>
        Before I joined Pilot, I helped lead <a href="https://xero.com">Xero's</a> accounting automation product group, where I worked on introducing AI to the core bank reconciliation product, and helped save small businesses millions of hours a year of manual bookkeeping work.
      </p>
      <p>
        Before that, I worked on international expansion and led Xero's launch in Asia. I grew the Asia team to more than 30 people, formed landmark product partnerships with major governments and banks in the region, built the product roadmap for key markets, and helped achieve MVP in those markets.
      </p>
      <p>
        In between all this, I took <Link to="/travel">a long break</Link>, most of which I spent travelling and learning to fly small planes. During those adventures I travelled 105,000 miles and visited India, Spain, France, Italy, Portugal, Brazil, Chile, Argentina, Colombia, Canada, China, Indonesia, Hong Kong, and the US.
      </p>
      <p>
        Way before that, I built and ran the Asia business for a global advertising & technology services group. Most of that was corporate development and I worked on (and closed! and integrated!) a series of acquisitions in Singapore, Malaysia, Indonesia, Vietnam and Thailand. It was a wild ride, but the end result is today a <a href="https://www.aleph-labs.com">wildly successful regional design & technology consultancy</a>.
      </p>
      <p>
        Even more way before that, I worked at a consultancy that is now known as AKQA. In the early days I built stuff (mostly web applications) for clients and managed the agency's content management and e-commerce products and its cloud hosting business.
      </p>
      <p>
        Over at <a href="https://www.airborn.co">Airborn.co</a>, I'm working on a fun open-source side project with the mission of making it easier for pilots to calculate how much runway they need to take off and land (Github repo <a href="https://github.com/alexjcampbell/Airborn/">here</a>)
      </p>
      <p>
        Along the way, I picked up some degrees: an MBA from the University of Chicago Booth School of Business, and a BA in History and Politics from the University of Melbourne.
      </p>
    </div>
  );
};

export default AboutAlex;
